import http from "./http";
import Service from "../Service";

export default class ProviderProductService extends Service {
    syncWinthorProducts(providerId, integrationId) {
        return http.post(
            `providers/${providerId}/products/${integrationId}/sync-winthor`,
            {},
            {
                headers: this.getHeaders(),
            }
        );
    }
}
